import Openable from './lib/openable';

class Drawer extends Openable {
  constructor({
    element, zIndex = { element: 50, overlay: 40 }, overlay = true, overlayTriggersClose = true,
  }) {
    super({
      element, zIndex, overlay, overlayTriggersClose,
    });

    this.classes = {
      active: 'drawer--active',
    };
  }
}

export default ({
  element, zIndex, overlay, overlayTriggersClose,
}) => new Drawer({
  element, zIndex, overlay, overlayTriggersClose,
});
